import React, { useState } from 'react'
import {useHistory } from 'react-router-dom';
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';

import { 
    GuestListTableContainer, 
} from './communication.style';

import {
    TableHead,
    TableBodyRow
} from '../../../../widget/styledComponents/table.style'
import Cookies from 'js-cookie';
import { gql,useQuery } from '@apollo/client';
import {Pagination, Spinner } from 'evergreen-ui'
import { FieldBtn } from './../resident/resident.style';
import CommunicationOnePageWidget from './communicationOnePageWidget';
import AddAssetsPlaceholder from '../../../../widget/add_assets_placeholder';



export const FETCH_COMMUNICATION = gql`
query Communications($pagination: PaginationInput!, $facilityId: ID!) {
  communications(pagination: $pagination, facilityId: $facilityId) {
    _id
    title
    image
    docs
    body
    type
    author {
      name
      email
    }
    hasBeenRead
    facility
    createdAt
    authorType
    id
    admin
    facilityManager
  }
}
`;

function CommPageWidget() {
const history = useHistory()
const facilityId = Cookies.get('facilityId');

const { loading, data }  = useQuery(FETCH_COMMUNICATION,{
    variables: {
        facilityId:facilityId,
        pagination: {
            "cursor": null,
            "limit": 100
        },
     },
    });

const [showOne,setShwoOne] = useState(false)
const [commOne,setCommOne] = useState(null)

  return (
    <div className=''>
        <br/>
        {!showOne &&
            <FieldBtn onClick={()=>history.push(`/addCommunication`)} class="mt-50 waves-effect waves-light btn-flat  ">
                <i class="material-icons left">add</i>
                Add Post
            </FieldBtn>
        }
        <br/><br/>
        <div className='row'>
            <div className='col s12 '>
                    {showOne &&
                        <span className='center' style={{
                            width:"30px",
                            height:"30px",
                        }}
                            onClick={()=>setShwoOne(false)}
                        >
                            <i className='material-icons center'>arrow_backwards</i>
                        </span>
                    }
                    
                    <PageTitleText>
                        Communication {showOne&& '- Post(Edit)'} 
                    </PageTitleText>
            </div>
            
        </div>  
        {!showOne &&
        <GuestListTableContainer>
            <table className='responsive-table'>
                <thead>
                <tr>
                    <TableHead>Title</TableHead>
                    <TableHead>Type</TableHead>
                    <TableHead>Author</TableHead>
                    <TableHead>Date Published</TableHead>
                </tr>
                </thead>

                <tbody>
                    {loading && <Spinner/> }
                    {data &&
                    
                    data.communications.map((data) => 
                        <TableBodyRow 
                        // onClick={()=>history.push(`/communicationOne/${data}`)}
                        onClick={()=>{
                            setShwoOne(true)
                            setCommOne(data)
                        }}
                    >
                            <td>{data.title}</td>
                            <td>{data.type}</td>
                            <td>{data.author.name}</td>
                            <td>{data.createdAt}</td>
                        </TableBodyRow>
                        )
                    }
                   
                </tbody>
            </table>
            <center>
                <AddAssetsPlaceholder/>
              </center>
            <Pagination className='transparent z-depth-0' page={1} totalPages={3}></Pagination>
        </GuestListTableContainer>
        }
        {showOne &&
            <CommunicationOnePageWidget  comOne={commOne} />
        }
    </div>
  )
}

export default CommPageWidget